import script from "./BaseGridLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseGridLoader.vue?vue&type=script&setup=true&lang=ts"

import "./BaseGridLoader.vue?vue&type=style&index=0&id=1139b6f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1139b6f0"]])

export default __exports__